module.exports = __webpack_public_path__ + "media/images/users/avatar-5-03588ec1a9ed9222330570871f487e44.jpg";